// Module
var code = "<svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M5 10L10 4.16667H6.66667L6.66667 0H3.33333V4.16667H0L5 10Z\" fill=\"#F03965\"/> </svg> ";
// Exports
module.exports = code;